/**
 * PDF related apis
 */

import { request } from './request';
import { 
  getPdfRequestConfig, 
  getFileUploadRequestConfig, 
  getRequestConfig,
  getBlobRequestConfig
} from './config';
import {
  PDF_UPLOAD_ACTION,
  REQUEST_PDF_ACTION,
  SAVE_PDF_ACTION,
  INSERT_GRAB_ACTION,
  GET_GRABBED_IMAGE_ACTION,
  ADD_EXTRACTION_ACTION,
  SAVE_EXTRACTION_ACTION,
  SEARCH_NPI_ACTION,
  SEARCH_CATEGORY_ACTION,
  SEARCH_PROCEDURE_ACTION,
  GET_PREVIEW_ACTION, 
  GET_GRABBED_PAGE_ACTION
} from './ajaxActions';
import {
  UPLOAD_PDF_SUCCESS_MESSAGE,
  GET_GRABBED_IMAGE_SUCCESS_MESSAGE,
  SAVE_EXTRACTION_SUCCESS_MESSAGE,
  GET_PREVIEW_SUCCESS_MESSAGE, 
  MISSING_CATEGORY_OR_PROCEDURE_MESSAGE
} from './ajaxActionResponse';
import { parsePdf } from './file/fileUtil';

/**
 * Uploads pdf to database
 * upload success reponse from server: {'message' : 'pdfUploadedMessage', 'id' : $idPDF, 'data': $allData}
 * @param {object} formData multipart form data, contains pdf
 */
export function uploadPdf (formData) {
  const config = getFileUploadRequestConfig(formData, PDF_UPLOAD_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      if (response && response.data.message === UPLOAD_PDF_SUCCESS_MESSAGE) {
        resolve(response);
      } else {
        reject(`unable to upload PDF: ${(response?response.data.message:'no reponse from server')}`);
      }
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

/**
 * Retrieves PDF as a document for viewing
 * request success reponse from server: {'message' : 'replyPDFMessage', 'id' : $idPDF, 'text': $PDFDoc}
 * @param {integer} id id of PDF to request
 */
export function getPdfById(id) {
  // const config = getPdfRequestConfig({id: id}, REQUEST_PDF_ACTION);
  const config = getPdfRequestConfig({id: id}, REQUEST_PDF_ACTION, '/file/pdfs');

  return new Promise((resolve, reject) => {
    request(config)
        .then((response) => {
          let pdf = parsePdf(atob(response.data.data.pdf));
          resolve({pdf: pdf});
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * @returns url to cropped image (or is it the stream)
 */
export function getGrabbedImage(requestParams) {
  const config = getRequestConfig(requestParams, GET_GRABBED_IMAGE_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response && response.data && response.data.message === GET_GRABBED_IMAGE_SUCCESS_MESSAGE) {
        resolve(response.data.url);
      } else {
        reject(`unable to get grab image: ${JSON.stringify(response)}`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}

/**
 * Inserts grabbed image to a page (specified in the request params)
 */
export function insertGrabRequest(requestParams) {
  const config = getRequestConfig(requestParams, INSERT_GRAB_ACTION);
    return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response) {
        resolve();
      } else {
        reject(`unable to insert grabbed image: ${JSON.stringify(response)}`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}

/** 
 * Saves the page number of the pdf last viewed
 */
export function savePages(requestParams) {
  const config = getRequestConfig(requestParams, SAVE_PAGE_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response) {
        resolve();
      } else {
        reject(`unable to save page: ${JSON.stringify(response)}`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function searchNpi(requestParams) {
  const config = getRequestConfig(requestParams, SEARCH_NPI_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response && response.data && response.data.npis) {
        resolve(response.data.npis);
      } else {
        reject(`No response from searchNpi request or too many responses.`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}


export function searchCategory(categoryDesc) {
  const config = getRequestConfig({description: categoryDesc}, SEARCH_CATEGORY_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response && response.data && response.data.categories) {
        resolve(response.data.categories);
      } else {
        reject(`No response from search category request`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function searchProcedure(procDesc) {
  const config = getRequestConfig({description: procDesc}, SEARCH_PROCEDURE_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      // TODO: get response data
      if (response && response.data && response.data.procedures) {
        resolve(response.data.procedures);
      } else {
        reject(`No response from search procedure request`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function saveExtractionIntoReport(requestParams) {
  const config = getRequestConfig(requestParams, SAVE_EXTRACTION_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response && response.data.message === SAVE_EXTRACTION_SUCCESS_MESSAGE) {
        resolve(response.data);
      } else if (response && response.data.message === MISSING_CATEGORY_OR_PROCEDURE_MESSAGE) {
        reject('Your report should at least have a document type or procedure.');
      } else {
        reject(`unable to save page: ${JSON.stringify(response)}`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
  
}

export function getPreview(requestParams) {
  const config = getBlobRequestConfig(requestParams, GET_PREVIEW_ACTION);

  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      if (response 
      && response.data 
      && response.data.message === GET_PREVIEW_SUCCESS_MESSAGE) {
        let preview = parsePdf(atob(response.data.preview));
        resolve({preview: preview});      
      } else {
        alert(' fail getPreview')

        reject(`unable to get preview: ${JSON.stringify(response)}`);
      }
    })
    .catch((err) => {
      reject(err);
    });
  });
}